<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="camera">
    <svg
      width="20px"
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
      class="svg-inline--fa fa-camera fa-w-16 fa-3x">
      <path fill="currentColor"
            d="M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
            class=""></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Camera',
};
</script>

<style scoped>
 .camera {
   cursor: pointer;
   border-radius: 40px;
   height: 40px;
   width: 40px;
   background-color: #F0DC00;
   display: flex;
   justify-content: center;
   align-items: center;
 }
</style>
